import { render, staticRenderFns } from "./BohrModelViz.vue?vue&type=template&id=5bdf2ca7&scoped=true"
import script from "./BohrModelViz.vue?vue&type=script&lang=js"
export * from "./BohrModelViz.vue?vue&type=script&lang=js"
import style0 from "./BohrModelViz.vue?vue&type=style&index=0&id=5bdf2ca7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdf2ca7",
  null
  
)

export default component.exports